




































import {Vue, Component, Prop} from 'vue-property-decorator';
import HoldTicket from "@/domainObjects/hold/HoldTicket";
import Plant from "@/domainObjects/Plant";
import TicketService from "@/services/TicketService";
import SearchHold from "@/domainObjects/hold/SearchHold";
import SearchWip from "@/domainObjects/wip/SearchWip";
import WipTicket from "@/domainObjects/wip/WipTicket";
import Email from "@/domainObjects/Email";

@Component({
})

export default class PlantPicker extends Vue {
    @Prop({required: false}) data!: HoldTicket | WipTicket | Email;
    @Prop({required: false}) search!: SearchHold | SearchWip;
    @Prop({required: false}) selectMultiple!: boolean;
    @Prop({required: false}) disabled!: boolean;
    @Prop({required: false}) filter!:boolean;

    plants:Plant[] = [];
    selectedPlant = {} as Plant;
    invalidPlant: Plant = {
      desc: 'Invalid Plant',
      text: 'Invalid Plant',
      value: '-1',
      code: '-1'
    }

    beforeMount() {
        TicketService.getPlants().then((response) =>{
            for( let plant of response.data ) {
                let mappedPlant:Plant = {code: plant.code, desc: plant.desc, value: plant.code, text: plant.desc };
                if (this.data){
                    if (mappedPlant.code!=='0'){
                        this.plants.push(mappedPlant)
                    }
                } else {
                    this.plants.push(mappedPlant);
                }

                //do not default to all if adding a ticket
                if (!this.data){
                    this.selectedPlant = this.plants[0];
                }
            }
            if (this.plants.length > 0) {
              this.plants.sort((a,b) => {
                if (a.desc > b.desc) {
                  return 1;
                } else if (a.desc < b.desc) {
                  return -1;
                } else {
                  return 0;
                }
              });
            }

            // passing plant code from table/search
            if (this.data && this.data.plant.code){
                let i = this.plants.findIndex(plant => plant.value === this.data.plant.code);
                this.selectedPlant = this.plants[i];
            }
            // passing plant directly from ticket
            if (this.data && this.data.plant && this.data.plant.code){
                let i = this.plants.findIndex(plant => plant.value === this.data.plant.code);
                if (i > -1) {
                  this.selectedPlant = this.plants[i];
                } else {
                  this.selectedPlant = this.invalidPlant
                }
            }
        })
    }

    selectPlant(event){
      if (event.target.value) {
        let value = this.plants.filter(plant => plant.code == event.target.value);
        this.$emit('selectPlant', value[0])
      }
    }
}
